export enum ALERT_DIALOG_VARIANTS {
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
  SUCCESS = 'success',
}
